import { MyLabel } from "../../../../components-config/StyledComponents";

const StyledLabel = MyLabel;

export default StyledLabel;
